<template>
    <div id="page" class="closed-mobile-header page-trademark-registration-process">
        <div class="menu-close-toggle hamburger-close-bg-enable hamburger-close-bg-hover-enable hamburger-close-border-enable hamburger-close-border-hover-enable">
            <div class="close-line-wrap"><span class="close-line"></span><span class="close-line"></span><span class="close-line"></span></div>
        </div>

        <div class="mobile-header-space"></div>


        <Header></Header>

        <div
            class="page-title title-center solid-bg breadcrumbs-off breadcrumbs-mobile-off page-title-responsive-enabled">
            <div class="wf-wrap">
                <div class="page-title-head hgroup"><h1 style="font-size: 30px!important;">Federal Trademark Registration Form</h1></div>
            </div>
        </div>
        <div id="main" class="sidebar-none sidebar-divider-vertical">
            <div class="wf-wrap">
                <div class="wf-container-main">
                    <div id="app">
                        <div class="preloader" style="
    position: absolute;
    background-size: 100%;
    top: 0;
    left: 0;
    bottom:0;
    right:0;
    width: 100%;
    height: 100%;
    z-index: 99999999;
    background-image: url('/images/untitled-5.gif'); /* your icon gif file path */
    background-repeat: no-repeat;
    background-color: #FFF;
    background-position: 50% 25%;
    display: none;
">
                            <div style="font: normal 700 24px/34px &quot;Roboto&quot;,Helvetica,Arial,Verdana,sans-serif; text-align: center;margin-top: 30%;font-size: 2em;
">Your Payment is Processing!
                            </div>
                        </div>
                        <!-- Content -->
                        <div id="content" class="content" role="main">
                            <div class="row clearfix">
                                <div class="col-lg-12" id="trademarkform">
                                    <div class="contact-widget">
                                        <div class="contact-form-result"></div>

                                        <form id="checkoutForm" method="post" enctype="multipart/form-data">
                                            <div class="module-checkout border1" id="step_1">
                                                <div class="template-registration-new-type-form">
                                                    <div class="ll-form-header">
                                                        <div>
                                                            <h2 style="margin: 0;" class="mainText">Submit Your TM Application With Trademark
                                                                Attorneys</h2>
                                                            <label class="lable-light totalPriceWrapper" style="font-size: 17px;border-bottom: 1px solid rgba(128, 128, 128, 0.29);padding: 10px 0px;">
                                                                <strong style="color:#0CC375">TOTAL DUE NOW:</strong>
                                                                <span id="total_due_text">
                                            ${{ number_format(totalItemsPrice) }} + ${{ number_format(totalCategoriesPrice) }} ({{ mainTextAdditionals }})
                                        </span>
                                                            </label>

                                                        </div>
                                                        <div>
                                                            <span style="color:#0CC375; text-transform: uppercase; font-size: small; letter-spacing: 0.8em; font-style: italic; font-weight: 800;">Powered By </span><br><img
                                                            src="http://www.cohnlg.com/wp-content/uploads/2019/04/lawpay_logo.png"
                                                            alt="lawpay logo"><br><img
                                                            src="http://www.cohnlg.com/wp-content/uploads/2019/05/creditcards.png"
                                                            alt="credit cards"></div>
                                                    </div>
                                                    <label class="lable-light">What kind of Trademark would you like to obtain?
                                                        <Popper>
                                                                    <span class="GetHelpItem">
                                                                        <i class="ppc icon-lightbulb popovericon" data-container="body" :data-trigger="popoverTrigger"
                                                                           data-toggle="popover" data-placement="right" data-html="true"
                                                                           data-original-title="" title=""

                                                                        >
                                                                        <span class="ppc i-get-help"><strong class="ppc"> Learn More</strong></span>
                                                                    </i>

                                                                    </span>
                                                            <template #content>
                                                                <div class="popper-content">
                                                                    <p class='text-center fs-16 lh-24 m-t-15'>
                                                                        <strong>Name</strong><br/>A Trademark on a Company
                                                                        Name or Product/Service Name is arguably the most
                                                                        important branding asset to have trademarked.<br/>
                                                                        <br/><strong>Slogan</strong><br/>&quot;Just Do It&quot;
                                                                        – Nike’s iconic slogan is one of the greatest
                                                                        trademarks of all time. What’s yours?<br/><br/><br/><strong>Logo</strong><br/>After
                                                                        your Company Logo is designed, it is time to protect
                                                                        it. Please describe what the logo looks like (shape,
                                                                        color, features).</p>
                                                                    </div>
                                                            </template>
                                                        </Popper>
                                                    </label>
                                                    <ul class="list-checkout-protect clearfix m-b-20 kind-trademark">
                                                        <li>
                                                            <div class="checkbox check-default checkbox-circle">
                                                                <input v-model="tm_type" type="radio" name="tm_type" value="name"
                                                                       id="tm_type_name" checked="checked">
                                                                <label class="lable-light" style="font-size: 19px;font-weight: bold;"
                                                                       for="tm_type_name">Name</label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="checkbox check-default checkbox-circle">
                                                                <input v-model="tm_type" type="radio" name="tm_type" value="logo"
                                                                       id="tm_type_logo">
                                                                <label class="lable-light" style="font-size: 19px;font-weight: bold;"
                                                                       for="tm_type_logo">Logo</label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="checkbox check-default checkbox-circle">
                                                                <input v-model="tm_type" type="radio" name="tm_type" value="slogan"
                                                                       id="tm_type_slogan">
                                                                <label class="lable-light" style="font-size: 19px;font-weight: bold;"
                                                                       for="tm_type_slogan">Slogan</label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="checkbox check-default checkbox-circle">
                                                                <input v-model="tm_type" type="radio" name="tm_type" value="name_logo"
                                                                       id="tm_type_name_logo">
                                                                <label class="lable-light" style="font-size: 19px;font-weight: bold;"
                                                                       for="tm_type_name_logo">Name + Logo</label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="checkbox check-default checkbox-circle">
                                                                <input v-model="tm_type" type="radio" name="tm_type" value="name_logo_slogan"
                                                                       id="tm_type_name_logo_slogan">
                                                                <label class="lable-light" style="font-size: 19px;font-weight: bold;"
                                                                       for="tm_type_name_logo_slogan">Name + Logo + Slogan</label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    <div id="blockWripper">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="name_trademark wrapper">
                                                                    <div v-for="(nameItem, key) in names" class="item">
                                                                        <label class="lable-light">
                                                                            <div id="tm_type_desc" style="color:#0CC375; font-weight: 700;">NAME OF TRADEMARK <span class="num">{{ names.length > 1 ? '#' + (key*1 + 1) : '' }}</span></div>
                                                                            <span id="character_limit"></span>
                                                                        </label>
                                                                        <div class="d-flex">
                                                                            <div class="w-70">
                                                                                <input type="text" v-model="nameItem.value" name="tm_name[]"
                                                                                       id="trademark_brand_name" maxlength="80"
                                                                                       data-id="tm_type_name" class="required form-control"
                                                                                       data-required="true">
                                                                            </div>
                                                                            <div class="itemRight">
                                                                                <p>Need to protect more than one Name?</p>
                                                                                <a class="btn btn-light addItem" @click.prevent="addName()" data-type="typesArrName" href="javascript:;"><i
                                                                                    class="fa fa-plus-circle"></i></a>
                                                                                <span style="color: #505c62">(<span class="text-decoration">Additional</span> ${{ itemPrice }}.00 + $350.00 Gov. Fee)</span>
                                                                                <div class="remove-item-top-wrap">
                                                                                    <span  v-if="key > 0" @click="names.splice(key,1)" class="remove-item-top">
                                                                                        Remove
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="logo_trademark wrapper">
                                                                    <div v-for="(logoItem, key) in logos" class="item" :class="'logo_top' + key">
                                                                        <label class="lable-light">
                                                                            <div id="tm_type_desc_logo"><span style="color: #0CC375;font-weight: 700;">LOGO <span class="num">{{ logos.length > 1 ? '#' + (key*1 + 1) : '' }}</span></span>
                                                                            </div>
                                                                        </label>
                                                                        <div class="d-flex">
                                                                            <div class="w-70">
                                                                                <template v-if="!logoItem.fileLater">
                                                                                    <div class="container drag-drop-container">
                                                                                        <form @drop="vdropzoneFileAdded($event.dataTransfer.files, key)" :class="'box has-advanced-upload form_box_' + key">
                                                                                        <div class="box__input">
                                                                                            <label :for="'file' + key" class="svg-upload-wrap">
                                                                                                <svg class="box__icon" xmlns="http://www.w3.org/2000/svg" width="50"
                                                                                                     height="43" viewBox="0 0 50 43">
                                                                                                    <path d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"></path>
                                                                                                </svg>
                                                                                            </label>
                                                                                            <input @change="vdropzoneFileAdded($event.target.files, key)" type="file" name="files[]" :id="'file' + key" class="box__file"
                                                                                                   data-multiple-caption="{count} files selected" multiple="">
                                                                                            <label class="drag-drop-label" :for="'file' + key"><strong>Choose a file</strong><span
                                                                                                class="box__dragndrop"> or drag it here</span>.</label>
                                                                                            <button type="submit" class="box__button">Upload</button>
                                                                                        </div>


                                                                                        <div class="box__uploading">Uploading…</div>
                                                                                        <div class="box__success">Done! <a
                                                                                            href=""
                                                                                            class="box__restart" role="button">Upload more?</a></div>
                                                                                        <div class="box__error">Error! <span></span>. <a
                                                                                            href=""
                                                                                            class="box__restart" role="button">Try again!</a></div>
                                                                                        <input type="hidden" name="ajax" value="1">
                                                                                    </form>
                                                                                    </div>
                                                                                    <input :value="logoItem.file ? 1 : ''" type="text" style="height: 0px!important;padding: 0;border: none" data-required="true" class="file-input">
                                                                                </template>
                                                                            </div>
                                                                            <div class="itemRight">
                                                                                <p>Need to protect an additional Logo?</p>
                                                                                <a class="btn btn-light addItem" @click.prevent="addLogo()" data-type="typesArrLogo" href="javascript:;"><i
                                                                                    class="fa fa-plus-circle"></i></a>
                                                                                <span>(<span class="text-decoration">Additional</span> ${{ itemPrice }}.00 + $350.00 Gov. Fee)</span>
                                                                                <div class="remove-item-top-wrap">
                                                                                    <span v-if="key > 0" @click="logos.splice(key,1)" class="remove-item-top">
                                                                                        Remove
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <label class="lable-light" id="tm_details_file_desc"
                                                                               style="margin-top: 10px;color: rgb(12, 195, 117);font-weight: 700;text-transform: uppercase;">Upload a Logo:</label><br>

                                                                        <div class="file-later-block checkbox check-default checkbox-circle">
                                                                            <label class="checkbox-container">
                                                                                <input type="checkbox"
                                                                                       :id="'fileLater' + key"
                                                                                       value="1"
                                                                                       v-model="logoItem.fileLater"
                                                                                       @change="setFileLater($event, key)"
                                                                                >
                                                                                <span class="checkmark"></span>
                                                                                <span class="label-inside">I’ll submit my Logo at a later point in time.</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="slogan_trademark wrapper">
                                                                    <div v-for="(nameSlogan, key) in slogans" class="item">
                                                                        <label class="lable-light">
                                                                            <div id="tm_type_slogan" style="color: #0CC375;font-weight: 700;">
                                                                                NAME OF SLOGAN <span class="num">{{ slogans.length > 1 ? '#' + (key*1 + 1) : '' }}</span></div>
                                                                            <span id="character_limit"></span></label>
                                                                        <div class="d-flex">
                                                                            <div class="w-70">
                                                                                <input v-model="nameSlogan.value" type="text"
                                                                                       name="tm_slogan[]" id="trademark_brand_slogan"
                                                                                       maxlength="80" data-id="tm_type_slogan"
                                                                                       class="required form-control" data-required="true">
                                                                            </div>
                                                                            <div class="itemRight">
                                                                                <p>Need to protect more than one Slogan?</p>
                                                                                <a class="btn btn-light addItem"
                                                                                   @click.prevent="addSlogan()"
                                                                                   data-type="typesArrSlogan" href="javascript:;"><i
                                                                                    class="fa fa-plus-circle"></i></a>
                                                                                <span>(<span class="text-decoration">Additional</span> ${{ itemPrice }}.00 + $350.00 Gov. Fee)</span>
                                                                                <div class="remove-item-top-wrap">
                                                                                    <span v-if="key > 0" @click="slogans.splice(key,1)" class="remove-item-top">
                                                                                        Remove
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <br>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <label class="lable-light" style="color: orange">Want to <span style="font-style: italic">Skip</span> the Trademark Search? Trademark Filing Fee is Only $450/Application
                                                        <Popper>
                                                                    <span class="GetHelpItem">
                                                                        <i class="ppc icon-lightbulb popovericon" data-container="body" :data-trigger="popoverTrigger"
                                                                           data-toggle="popover" data-placement="right" data-html="true"
                                                                           data-original-title="" title=""

                                                                        >
                                                                        <span class="ppc i-get-help"><strong class="ppc"> Learn More</strong></span>
                                                                    </i>

                                                                    </span>
                                                            <template #content>
                                                                <div class="popper-content">
                                                                    <p class='text-center fs-16 lh-24 m-t-15'>The
                                                                        central test for infringement in trademark
                                                                        law is 'Likelihood of Confusion', not, 'Does
                                                                        the name Exist'. So, the search that we will
                                                                        do with the USPTO is conducted with this
                                                                        question in mind and considers permutations
                                                                        of the mark, relevance to the industry,
                                                                        co-existence of similar marks etc. If you
                                                                        would like to skip the Trademark Search
                                                                        portion of the process, we charge a legal
                                                                        service fee of only $450.</p>
                                                                </div>
                                                            </template>
                                                        </Popper>
                                                    </label>

                                                    <ul class="list-checkout-protect clearfix m-b-20 kind-trademark">
                                                        <li>
                                                            <div class="checkbox check-default checkbox-circle">
                                                                <input v-model="skipTrademarkSearch" type="radio" name="skipTrademarkSearch" value="1"
                                                                       id="skipTrademarkSearchYes" checked="checked">
                                                                <label class="lable-light" style="font-size: 19px;font-weight: bold;"
                                                                       for="skipTrademarkSearchYes">Yes</label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="checkbox check-default checkbox-circle">
                                                                <input v-model="skipTrademarkSearch" type="radio" name="skipTrademarkSearch" value=""
                                                                       id="skipTrademarkSearchNo">
                                                                <label class="lable-light" style="font-size: 19px;font-weight: bold;"
                                                                       for="skipTrademarkSearchNo">No</label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <Owner
                                                    :start_ownership_type="ownership_type"
                                                    @change_ownership_type="ownership_type = $event"
                                                    :start_ownershipIndividuals="ownershipIndividuals"
                                                    @change_ownershipIndividuals="ownershipIndividuals = $event"
                                                    :start_ownershipCompanies="ownershipCompanies"
                                                    @change_ownershipCompanies="ownershipCompanies = $event"
                                                ></Owner>

                                                <label class="bold"><span class="more-big">Are you in the business of selling a product or a service?</span> <span
                                                    class="required">*</span>
                                                    <Popper>
                                                                    <span class="GetHelpItem">
                                                                        <i class="ppc icon-lightbulb popovericon" data-container="body" :data-trigger="popoverTrigger"
                                                                           data-toggle="popover" data-placement="right" data-html="true"
                                                                           data-original-title="" title=""

                                                                        >
                                                                        <span class="ppc i-get-help"><strong class="ppc"> Learn More</strong></span>
                                                                    </i>

                                                                    </span>
                                                        <template #content>
                                                            <div class="popper-content">
                                                                <p class='text-center lh-24 m-t-15'>Here, the meaning of
                                                                    the words &quot;Product&quot; and &quot;Service&quot;
                                                                    is relatively straightforward. If you are selling an
                                                                    actual item, you may select product. However, if you
                                                                    are in the business of providing a service (like an
                                                                    accountant or dentist), you may select service. Of
                                                                    course, you may very well be selling both in which
                                                                    case you'd select Products and Services.</p>
                                                            </div>
                                                        </template>
                                                    </Popper>

                                                </label>
                                                <p class="color-blue mar-bottom-20 fs-14">Identify whether or not you intend to sell actual
                                                    products, services to your customers, or perhaps even both.</p>
                                                <ul class="list-checkout-protect step_3_lists clearfix">
                                                    <li class="m-b-15">
                                                        <div class="checkbox check-default checkbox-circle">
                                                            <input type="radio" v-model="class_type" name="class_type" value="Goods" id="class_type_goods">
                                                            <label for="class_type_goods">Products</label>
                                                        </div>
                                                    </li>
                                                    <li class="m-b-15">
                                                        <div class="checkbox check-default checkbox-circle">
                                                            <input type="radio" v-model="class_type" name="class_type" value="Services" id="class_type_services">
                                                            <label for="class_type_services">Services</label>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div class="checkbox check-default checkbox-circle">
                                                            <input type="radio" v-model="class_type" name="class_type" value="Both" id="class_type_both"><label
                                                            style="display:inline; margin-left:2px;" for="class_type_both">Products
                                                            and Services
                                                            <span class="">(which will require additional USPTO filing fees* for multiple
                    filings)
                </span>

                                                            <Popper>
                                                                    <span class="GetHelpItem">
                                                                        <i class="ppc icon-lightbulb popovericon" data-container="body" :data-trigger="popoverTrigger"
                                                                           data-toggle="popover" data-placement="right" data-html="true"
                                                                           data-original-title="" title=""

                                                                        >
                                                                        <span class="ppc i-get-help"><strong class="ppc"> Learn More</strong></span>
                                                                    </i>

                                                                    </span>
                                                                <template #content>
                                                                    <div class="popper-content">
                                                                        <p class='text-center lh-24 m-t-10'>The USPTO
                                                                            unfortunately requires separate filing fees
                                                                            if you are registering both a products and a
                                                                            service. <br/> <br/>The USPTO categorizes
                                                                            products and services according to &quot;classes&quot;.
                                                                            Which one of the following best categorizes
                                                                            your industry?</p>
                                                                    </div>
                                                                </template>
                                                            </Popper>
                                                        </label>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div class="select_class">
                                                    <template v-for="(nameItem, nameKey) in names">
                                                        <div v-if="class_type && nameItem.categoriesGoods.length" class="row bottom-margin-25 class_select" data-class="Name">
                                                            <div class="col-md-12"><label for="class" class="mar-bottom-25 bold">Name Trademark {{ names.length > 1 ? '#' + (nameKey + 1) + ' ' : '' }}- Select your Product
                                                                Category <span class="required">*</span> </label>
                                                                <template v-for="(category, key) in nameItem.categoriesGoods">
                                                                    <div class="select_wrapper bottom-margin-25">
                                                                        <div class="select-container" style="position:relative;display:flex;align-items:center;">
                                                                            <select v-model="names[nameKey].categoriesGoods[key]" data-required="true" :name="'good[' + key + '][Name]'" class="form-control bottom-margin-40 select_cat" style="max-width: 650px;font-weight: bolder;text-decoration: underline;border: 2px solid #cccccc;">
                                                                                <template v-for="(itemClassTypeGoods, itemClassTypeGoodsKey) in listClassTypeGoods">
                                                                                    <option :value="itemClassTypeGoodsKey">{{ itemClassTypeGoods }}</option>
                                                                                </template>
                                                                            </select>
                                                                            <div v-if="nameItem.categoriesGoods.length == key + 1" class="addSelect itemRight"><p>Selling more than one Category of Product?</p>
                                                                                <a @click.prevent="names[nameKey].categoriesGoods.push('')" class="btn btn-light addItemClone" data-type="typesArrName" href="#" style="margin-right: 5px;">
                                                                                    <i class="fa fa-plus-circle"></i>
                                                                                </a>
                                                                                <span>(Add Category: Gov. Fee $350.00)</span>
                                                                                <div class="remove-item-top-wrap">
                                                                                    <span v-if="key != 0 && nameItem.categoriesGoods.length == key + 1" @click="names[nameKey].categoriesGoods.splice(key,1)" class="remove-item-top">
                                                                                        Remove
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>

                                                        <div v-if="class_type && nameItem.categoriesServices.length" class="row bottom-margin-25 class_select" data-class="Name">
                                                            <div class="col-md-12"><label for="class" class="mar-bottom-25 bold">Name Trademark {{ names.length > 1 ? '#' + (nameKey + 1) + ' ' : '' }}- Select your Service
                                                                Category <span class="required">*</span> </label>
                                                                <template v-for="(category, key) in nameItem.categoriesServices">
                                                                    <div class="select_wrapper bottom-margin-25">
                                                                        <div class="select-container" style="position:relative;display:flex;align-items:center;">
                                                                            <select v-model="names[nameKey].categoriesServices[key]" data-required="true" :name="'service[' + key + '][Name]'"
                                                                                    class="form-control bottom-margin-40 select_cat"
                                                                                    style="max-width: 650px;font-weight: bolder;text-decoration: underline;border: 2px solid #cccccc;">
                                                                                <template v-for="(itemClassTypeService, itemClassTypeServiceKey) in listClassTypeService">
                                                                                    <option :value="itemClassTypeServiceKey">{{ itemClassTypeService }}</option>
                                                                                </template>
                                                                            </select>
                                                                            <div v-if="nameItem.categoriesServices.length == key + 1" class="addSelect itemRight"><p>Selling more than one Category of Service?</p>
                                                                                <a @click.prevent="names[nameKey].categoriesServices.push('')" class="btn btn-light addItemClone" data-type="typesArrName" href="javascript:;"
                                                                                   style="margin-right: 5px;"><i class="fa fa-plus-circle"></i></a><span>(Add Category: Gov. Fee $350.00)</span>
                                                                                <div class="remove-item-top-wrap">
                                                                                    <span v-if="key != 0 && nameItem.categoriesServices.length == key + 1" @click="names[nameKey].categoriesServices.splice(key,1)" class="remove-item-top">
                                                                                        Remove
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template v-for="(logoItem, logoKey) in logos">
                                                        <div v-if="class_type && logoItem.categoriesGoods.length" class="row bottom-margin-25 class_select" data-class="Name">
                                                            <div class="col-md-12"><label for="class" class="mar-bottom-25 bold">Logo Trademark {{ logos.length > 1 ? '#' + (logoKey + 1) + ' ' : '' }}- Select your Product
                                                                Category <span class="required">*</span> </label>
                                                                <template v-for="(category, key) in logoItem.categoriesGoods">
                                                                    <div class="select_wrapper bottom-margin-25">
                                                                        <div class="select-container" style="position:relative;display:flex;align-items:center;">
                                                                            <select v-model="logos[logoKey].categoriesGoods[key]" data-required="true" name="'good[' + key + '][Logo]'" class="form-control bottom-margin-40 select_cat"
                                                                                    style="max-width: 650px;font-weight: bolder;text-decoration: underline;border: 2px solid #cccccc;">
                                                                                <template v-for="(itemClassTypeGoods, itemClassTypeGoodsKey) in listClassTypeGoods">
                                                                                    <option :value="itemClassTypeGoodsKey">{{ itemClassTypeGoods }}</option>
                                                                                </template>
                                                                            </select>
                                                                            <div v-if="logoItem.categoriesGoods.length == key + 1" class="addSelect itemRight"><p>Selling more than one Category of Product?</p>
                                                                                <a @click.prevent="logos[logoKey].categoriesGoods.push('')" class="btn btn-light addItemClone" data-type="typesArrName" href="javascript:;"
                                                                                   style="margin-right: 5px;"><i class="fa fa-plus-circle"></i></a><span>(Add Category: Gov. Fee $350.00)</span>
                                                                                <div class="remove-item-top-wrap">
                                                                                    <span v-if="key != 0 && logoItem.categoriesGoods.length == key + 1" @click="logos[logoKey].categoriesGoods.splice(key,1)" class="remove-item-top">
                                                                                        Remove
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>

                                                        <div v-if="class_type && logoItem.categoriesServices.length" class="row bottom-margin-25 class_select" data-class="Name">
                                                            <div class="col-md-12"><label for="class" class="mar-bottom-25 bold">Logo Trademark {{ logos.length > 1 ? '#' + (logoKey + 1) + ' ' : '' }}- Select your Service
                                                                Category <span class="required">*</span> </label>
                                                                <template v-for="(category, key) in logoItem.categoriesServices">
                                                                    <div class="select_wrapper bottom-margin-25">
                                                                        <div class="select-container" style="position:relative;display:flex;align-items:center;">
                                                                            <select v-model="logos[logoKey].categoriesServices[key]" data-required="true" :name="'service[' + key + '][Logo]'"
                                                                                    class="form-control bottom-margin-40 select_cat"
                                                                                    style="max-width: 650px;font-weight: bolder;text-decoration: underline;border: 2px solid #cccccc;">
                                                                                <template v-for="(itemClassTypeService, itemClassTypeServiceKey) in listClassTypeService">
                                                                                    <option :value="itemClassTypeServiceKey">{{ itemClassTypeService }}</option>
                                                                                </template>
                                                                            </select>
                                                                            <div v-if="logoItem.categoriesServices.length == key + 1" class="addSelect itemRight"><p>Selling more than one Category of Service?</p>
                                                                                <a @click.prevent="logos[logoKey].categoriesServices.push('')" class="btn btn-light addItemClone" data-type="typesArrName" href="javascript:;"
                                                                                   style="margin-right: 5px;"><i class="fa fa-plus-circle"></i></a><span>(Add Category: Gov. Fee $350.00)</span>
                                                                                <div class="remove-item-top-wrap">
                                                                                    <span v-if="key != 0 && logoItem.categoriesServices.length == key + 1" @click="logos[logoKey].categoriesServices.splice(key,1)" class="remove-item-top">
                                                                                        Remove
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>

                                                    </template>
                                                    <template v-for="(sloganItem, sloganKey) in slogans">

                                                        <div v-if="class_type && sloganItem.categoriesGoods.length" class="row bottom-margin-25 class_select" data-class="Name">
                                                            <div class="col-md-12"><label for="class" class="mar-bottom-25 bold">Slogan Trademark {{ slogans.length > 1 ? '#' + (sloganKey + 1) + ' ' : '' }}- Select your Product
                                                                Category <span class="required">*</span> </label>
                                                                <template v-for="(category, key) in sloganItem.categoriesGoods">
                                                                    <div class="select_wrapper bottom-margin-25">
                                                                        <div class="select-container" style="position:relative;display:flex;align-items:center;">
                                                                            <select v-model="slogans[sloganKey].categoriesGoods[key]" data-required="true" :name="'good[' + key + '][Slogan]'" class="form-control bottom-margin-40 select_cat"
                                                                                    style="max-width: 650px;font-weight: bolder;text-decoration: underline;border: 2px solid #cccccc;">
                                                                                <template v-for="(itemClassTypeGoods, itemClassTypeGoodsKey) in listClassTypeGoods">
                                                                                    <option :value="itemClassTypeGoodsKey">{{ itemClassTypeGoods }}</option>
                                                                                </template>
                                                                            </select>
                                                                            <div v-if="sloganItem.categoriesGoods.length == key + 1" class="addSelect itemRight"><p>Selling more than one Category of Product?</p>
                                                                                <a @click.prevent="slogans[sloganKey].categoriesGoods.push('')" class="btn btn-light addItemClone" data-type="typesArrName" href="javascript:;"
                                                                                   style="margin-right: 5px;"><i class="fa fa-plus-circle"></i></a><span>(Add Category: Gov. Fee $350.00)</span>
                                                                                <div class="remove-item-top-wrap">
                                                                                    <span v-if="key != 0 && sloganItem.categoriesGoods.length == key + 1" @click="slogans[sloganKey].categoriesGoods.splice(key,1)" class="remove-item-top">
                                                                                        Remove
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>


                                                        <div v-if="class_type && sloganItem.categoriesServices.length" class="row bottom-margin-25 class_select" data-class="Name">
                                                            <div class="col-md-12"><label for="class" class="mar-bottom-25 bold">Slogan Trademark {{ slogans.length > 1 ? '#' + (sloganKey + 1) + ' ' : '' }}- Select your Service
                                                                Category <span class="required">*</span> </label>
                                                                <template v-for="(category, key) in sloganItem.categoriesServices">
                                                                    <div class="select_wrapper bottom-margin-25">
                                                                        <div class="select-container" style="position:relative;display:flex;align-items:center;">
                                                                            <select v-model="slogans[sloganKey].categoriesServices[key]" data-required="true" :name="'service[' + key + '][Slogan]'"
                                                                                    class="form-control bottom-margin-40 select_cat"
                                                                                    style="max-width: 650px;font-weight: bolder;text-decoration: underline;border: 2px solid #cccccc;">
                                                                                <template v-for="(itemClassTypeService, itemClassTypeServiceKey) in listClassTypeService">
                                                                                    <option :value="itemClassTypeServiceKey">{{ itemClassTypeService }}</option>
                                                                                </template>
                                                                            </select>
                                                                            <div v-if="sloganItem.categoriesServices.length == key + 1" class="addSelect itemRight"><p>Selling more than one Category of Service?</p>
                                                                                <a @click.prevent="slogans[sloganKey].categoriesServices.push('')" class="btn btn-light addItemClone" data-type="typesArrName" href="javascript:;"
                                                                                   style="margin-right: 5px;"><i class="fa fa-plus-circle"></i></a><span>(Add Category: Gov. Fee $350.00)</span>
                                                                                <div class="remove-item-top-wrap">
                                                                                    <span v-if="key != 0 && sloganItem.categoriesServices.length == key + 1" @click="slogans[sloganKey].categoriesServices.splice(key,1)" class="remove-item-top">
                                                                                        Remove
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>

                                                    </template>

                                                </div>

                                                <div class="divider m-b-45"></div>

                                                <div class="row">
                                                    <div class="col-md-12 col-xs-12">
                                                        <label class="mar-bottom-20 lh-24 bold">
                                        <span id="class_description_label"><span class="more-big">Provide a few more details regarding the products/services you plan on selling.</span>
                                        </span>
                                                            <span class="required">*</span></label>
                                                        <textarea v-model="class_description" class="form-control" name="class_description" style="height: 103px;"
                                                                  data-required="true"></textarea>
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top:25px;">
                                                    <div class="col-sm-6">
                                                        <div class="lock-dark"><i class="icon-ok-sign"></i> Click on "Finish" to complete
                                                            your Application.
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6 text-right finishBtn">
                                                        <a @click.prevent="nextStepBtn" class="btn btn-orange nextStepBtn" href="javascript:;" id="nextStepBtn1">FINISH
                                                            <i class="fa fa-angle-right"></i></a>
                                                    </div>
                                                </div>

                                                <p style="color:#0CC375; text-transform: uppercase; font-size: large; letter-spacing: 0.3em; font-style: italic; font-weight: 800;text-align: center; padding-top: 30px;">
                                                    LawPay Means Security: </p>
                                                <div class="ll-form-header">
                                                    <img src="http://www.cohnlg.com/wp-content/uploads/2019/05/1.png" alt="Trustpilot">
                                                    <img src="http://www.cohnlg.com/wp-content/uploads/2019/05/2.png" alt="Inc 5000">
                                                    <img src="http://www.cohnlg.com/wp-content/uploads/2019/05/3.png"
                                                         alt="EY Entrepreneur of the year">
                                                    <img src="http://www.cohnlg.com/wp-content/uploads/2019/05/4.png" alt="Fast 50">
                                                </div>
                                            </div>


                                            <input type="hidden" name="priceamount" id="priceamount" :value="totalPrice"/>

                                        </form>

                                        <form action="javascript:void(0);" name="paymentfrm" id="paymentfrm">
                                            <a v-if="pageNum == 2" href="#" @click.prevent="backStepBtn" class="top-link-back"><span style="text-decoration: underline;">BACK</span> <i class="fa fa-arrow-left"></i></a>
                                            <div class="step_71 row equal_height equal_height_custom module-checkout border1 noPaddingMobile hide"
                                                 id="step_7">
                                                <div class="container clearfix ">

                                                    <div class="col_half payment-form" id="payment-form">
                                                        <div class="payment-form-inner">
                                                            <h3 @click="paymentInformationShowHandler" class="payment-dropdown-h3" style="cursor: pointer" :style="paymentInformationShow ? 'margin-bottom:30px' : 'margin-bottom:0px'">Payment Information <i class="fa paymentUpDown" :class="paymentInformationShow ? 'fa-angle-up' : 'fa-angle-down'"></i></h3>
                                                            <div class="paymentInformationInfo" style="overflow:hidden; transition-property: height; transition-duration: 1s; height: 0">
                                                                <div>
                                                                    <div class="field">
                                                                        <label>Cardholder Name <span class="required">*</span></label>
                                                                        <input type="text" name="name" placeholder="Cardholder Name"
                                                                               class="cardholder-name form-control mar-bottom-25"
                                                                               style="margin-bottom: 4px!important;" data-required="true">
                                                                        <span class="credit-card-name"
                                                                              style="font-size: initial;color: #fe9d39;"></span>
                                                                    </div>
                                                                    <div class="field">
                                                                        <label>Credit Card Number <span class="required">*</span></label>
                                                                        <input type="text" name="number" placeholder="____ ____ ____ ____" id="ck"
                                                                               class="form-control mar-bottom-25" maxlength="19"
                                                                               style="background-image: url(/images/front.jpg);background-position: right 10px center;background-repeat: no-repeat;background-size: 43px auto;font-size: 14pt; margin-bottom: 4px!important;margin-top: 9px;padding: 5px 45px 5px 5px;"
                                                                               data-required="true">
                                                                        <span class="credit-card-number"
                                                                              style="font-size: initial;color: #fe9d39;"></span>
                                                                    </div>
                                                                    <div class="field">
                                                                        <label style="width:100%">Expiration Date <span
                                                                            class="required">*</span></label>
                                                                        <input type="text" name="exp_month" placeholder="MM"
                                                                               class="form-control mar-bottom-25" maxlength="2" data-required="true"
                                                                               style="max-width:49%;display:inline-block;margin-bottom: 4px!important;">
                                                                        <input type="text" name="exp_year" maxlength="4" placeholder="YYYY"
                                                                               class="form-control mar-bottom-25"
                                                                               style="display:inline-block; max-width:49%;margin-bottom: 4px!important;"
                                                                               data-required="true">
                                                                        <span class="exp_year_month"
                                                                              style="font-size: initial;color: #fe9d39;"></span>
                                                                    </div>
                                                                    <div class="field">
                                                                        <label style="width:100%" for="example2-card-cvc"
                                                                               data-tid="elements_examples.form.card_cvc_label">CVC <span
                                                                            class="required">*</span>
                                                                        </label>
                                                                        <input type="text" name="cvv" maxlength="4" placeholder="CVC"
                                                                               @click="billingInformationShowHandlerAddition"
                                                                               style="background-image: url(/images/cvv.jpg);background-position: right 10px center;background-repeat: no-repeat;background-size: 43px auto;font-size: 14pt;margin-top: 9px;padding: 5px 45px 5px 5px;margin-bottom: 4px!important;"
                                                                               class="form-control mar-bottom-25" data-required="true">
                                                                        <span class="cvc"
                                                                              style="font-size: initial;color: #fe9d39;margin-bottom: 4px!important;"></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="payment-form-inner">
                                                            <h3 @click="billingInformationShowHandler" class="payment-dropdown-h3" style="cursor: pointer" :style="billingInformationShow ? 'margin-bottom:30px' : 'margin-bottom:0px'">Billing Information <i class="fa paymentUpDown" :class="billingInformationShow ? 'fa-angle-up' : 'fa-angle-down'"></i></h3>
                                                            <div class="billingInformationInfo" style="overflow:hidden; transition-property: height; transition-duration: 1s; height: 0">
                                                                <div>
                                                                    <div class="field mar-bottom-25">
                                                                        <label for="example2-address"
                                                                               data-tid="elements_examples.form.address_label">Billing Address <span
                                                                            class="required">*</span></label>
                                                                        <input id="example2-address" v-model="paymentForm.billing_address"
                                                                               data-tid="elements_examples.form.address_placeholder" name="address1"
                                                                               class="input empty form-control" type="text"
                                                                               placeholder="123 Billing St" data-required="true">
                                                                        <div class="baseline"></div>
                                                                    </div>
                                                                    <div class="field half-width mar-bottom-25">
                                                                        <label for="example2-city" data-tid="elements_examples.form.city_label">Billing
                                                                            City <span class="required">*</span></label>
                                                                        <input v-model="paymentForm.billing_city" id="example2-city" data-tid="elements_examples.form.city_placeholder"
                                                                               name="city" class="input empty form-control" type="text"
                                                                               placeholder="Billing City" data-required="true">
                                                                        <div class="baseline"></div>
                                                                    </div>
                                                                    <div class="field quarter-width mar-bottom-25">
                                                                        <label for="example2-state" data-tid="elements_examples.form.state_label">Billing
                                                                            State <span class="required">*</span></label>
                                                                        <input v-model="paymentForm.billing_state" id="example2-state"
                                                                               data-tid="elements_examples.form.state_placeholder" name="state"
                                                                               class="input empty form-control" type="text" placeholder="CA"
                                                                               data-required="true">
                                                                        <div class="baseline"></div>
                                                                    </div>
                                                                    <div class="field quarter-width mar-bottom-25">
                                                                        <label for="example2-zip"
                                                                               data-tid="elements_examples.form.postal_code_label">Billing Zip Code
                                                                            <span class="required">*</span></label>
                                                                        <input v-model="paymentForm.billing_zip_code" id="example2-zip"
                                                                               data-tid="elements_examples.form.postal_code_placeholder"
                                                                               name="postal_code" class="input empty form-control" type="text"
                                                                               placeholder="12345" data-required="true">
                                                                        <div class="baseline"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col_two_fifth float-right">
                                                        <div class="puchase-details">
                                                            <div class="puchase-content" style="background: #ffffff">
                                                                <h3 class="title">Order Summary</h3>
                                                                <table style="margin-bottom: 5px;">
                                                                    <tbody>
                                                                    <tr class="hidden">
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr @click="legalServicesInfoShow =!legalServicesInfoShow" style="cursor: pointer">
                                                                        <td id="trademark_package"><b>Legal Services:</b></td>
                                                                        <td>$<span id="trademark_package_amount">
                                                            {{ number_format(totalItemsPrice) }}
                                                        </span> <i class="fa paymentUpDown" :class="legalServicesInfoShow ? 'fa-angle-up' : 'fa-angle-down'"></i></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colspan="2" style="padding: 0; border:none">
                                                                            <div class="legalServicesInfo" style="overflow:hidden; transition-property: height; transition-duration: 1s;height: 0">
                                                                                <table>
                                                                                    <tr v-for="(nameItem, key) in names">
                                                                                        <td>Name of Trademark {{ names.length > 1 ? '#' + (key*1 + 1) : '' }}</td>
                                                                                        <td>{{ nameItem.value }}</td>
                                                                                        <td>${{ number_format(itemPrice) }}</td>
                                                                                    </tr>
                                                                                    <tr v-for="(nameSlogan, key) in slogans">
                                                                                        <td>Slogan of Trademark {{ slogans.length > 1 ? '#' + (key*1 + 1) : '' }}</td>
                                                                                        <td>{{ nameSlogan.value }}</td>
                                                                                        <td>${{ number_format(itemPrice) }}</td>
                                                                                    </tr>
                                                                                    <tr v-for="(logoItem, key) in logos">
                                                                                        <td>Logo {{ logos.length > 1 ? '#' + (key*1 + 1) : '' }}</td>
                                                                                        <td></td>
                                                                                        <td>${{ number_format(itemPrice) }}</td>
                                                                                    </tr>
                                                                                </table>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr id="trademark_type_disp" @click="governmentFeeInfoShow =!governmentFeeInfoShow" style="cursor: pointer">
                                                                        <td><b>Government Fee:</b></td>
                                                                        <td>$<span id="trademark_type_amount">{{ number_format(totalCategoriesPrice) }}</span><i class="fa paymentUpDown" :class="governmentFeeInfoShow ? 'fa-angle-up' : 'fa-angle-down'"></i></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colspan="2" style="padding: 0; border:none">
                                                                            <div class="governmentFeeInfo" style="overflow:hidden; transition-property: height; transition-duration: 1s;height: 0">
                                                                                <table>
                                                                                    <template v-for="(nameItem, nameKey) in names">
                                                                                        <template v-if="class_type && nameItem.categoriesGoods.length">
                                                                                            <tr v-for="(category, key) in nameItem.categoriesGoods">
                                                                                                <td>Name Trademark {{ names.length > 1 ? '#' + (nameKey + 1) + ' ' : '' }}- Product Category</td>
                                                                                                <td>{{ names[nameKey].categoriesGoods[key] }}</td>
                                                                                                <td>${{ number_format(350) }}</td>
                                                                                            </tr>
                                                                                        </template>

                                                                                        <template v-if="class_type && nameItem.categoriesServices.length">
                                                                                            <tr v-for="(category, key) in nameItem.categoriesServices">
                                                                                                <td>Name Trademark {{ names.length > 1 ? '#' + (nameKey + 1) + ' ' : '' }}- Service Category</td>
                                                                                                <td>{{ names[nameKey].categoriesServices[key] }}</td>
                                                                                                <td>${{ number_format(350) }}</td>
                                                                                            </tr>
                                                                                        </template>
                                                                                    </template>

                                                                                    <template v-for="(logoItem, logoKey) in logos">
                                                                                        <template v-if="class_type && logoItem.categoriesGoods.length">
                                                                                            <tr v-for="(category, key) in logoItem.categoriesGoods">
                                                                                                <td>Logo Trademark {{ logos.length > 1 ? '#' + (logoKey + 1) + ' ' : '' }}- Product Category</td>
                                                                                                <td>{{ logos[logoKey].categoriesGoods[key] }}</td>
                                                                                                <td>${{ number_format(350) }}</td>
                                                                                            </tr>
                                                                                        </template>

                                                                                        <template v-if="class_type && logoItem.categoriesServices.length">
                                                                                            <tr v-for="(category, key) in logoItem.categoriesServices">
                                                                                                <td>Logo Trademark {{ logos.length > 1 ? '#' + (logoKey + 1) + ' ' : '' }}- Service Category</td>
                                                                                                <td>{{ logos[logoKey].categoriesServices[key] }}</td>
                                                                                                <td>${{ number_format(350) }}</td>
                                                                                            </tr>
                                                                                        </template>
                                                                                    </template>

                                                                                    <template v-for="(sloganItem, sloganKey) in slogans">
                                                                                        <template v-if="class_type && sloganItem.categoriesGoods.length">
                                                                                            <tr v-for="(category, key) in sloganItem.categoriesGoods">
                                                                                                <td>Slogan Trademark {{ slogans.length > 1 ? '#' + (sloganKey + 1) + ' ' : '' }}- Product Category</td>
                                                                                                <td>{{ slogans[sloganKey].categoriesGoods[key] }}</td>
                                                                                                <td>${{ number_format(350) }}</td>
                                                                                            </tr>
                                                                                        </template>

                                                                                        <template v-if="class_type && sloganItem.categoriesServices.length">
                                                                                            <tr v-for="(category, key) in sloganItem.categoriesServices">
                                                                                                <td>Slogan Trademark {{ slogans.length > 1 ? '#' + (sloganKey + 1) + ' ' : '' }}- Service Category</td>
                                                                                                <td>{{ slogans[sloganKey].categoriesServices[key] }}</td>
                                                                                                <td>${{ number_format(350) }}</td>
                                                                                            </tr>
                                                                                        </template>
                                                                                    </template>
                                                                                </table>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            <div class="total" style="font-size: 24px;">Total</div>
                                                                        </td>
                                                                        <td>
                                                                            <div class="total-price">
                                                                                $<span id="total-price">
                                                                {{ number_format(totalPrice) }}
                                                            </span>&nbsp;
                                                                            </div>
                                                                        </td>
                                                                    </tr>

                                                                    </tbody>
                                                                </table>
                                                                <!--                                            <div style="margin-bottom: 25px;">-->
                                                                <!--                                                <label class="lable-light">-->
                                                                <!--                                                    <div style="color:#0CC375; font-weight: 700;">CLIENT CODE</div>-->
                                                                <!--                                                </label>-->
                                                                <!--                                                <input type="text" style="width: 70%;float: right;" name="promo" id="promo_code" maxlength="80" class="form-control" data-required="true">-->
                                                                <!--                                            </div>-->
                                                                <div style="overflow-y: scroll; height:163px; padding: 13px 20px; font-size: 12px; border: 1px solid #dfe1e2; line-height: 20px; margin-bottom:15px;">
                                                                    <template v-if="skipTrademarkSearch">
                                                                        <strong>1. THE PARTIES / EFFECTIVE DATE.</strong> This Agreement is made between Cohn Legal, PLLC (“Attorney“) and You (“Client“) and is effective as of the latest date of signing by Client.
                                                                        <br/>
                                                                        <strong>2. LEGAL SERVICES PROVIDED,</strong> RESPONSIBILITIES OF ATTORNEY AND CLIENT. The Legal Services to be provided by Attorney to Client are the preparation and filing of Client’s trademark application, monitoring Client’s trademark application once filed, and responding to any “Procedural“ Office Actions issued by the USPTO which require thirty (30) minutes of time or less to answer (“Legal Services“). All additional services, namely responding to Substantive office actions including “Likelihood of Confusion rejections“ and “Descriptive rejections“ will be billed according to a per project basis. These additional charges will be discussed with the Client before Attorney commences work. Client will be cooperative and responsive, providing necessary information and monies for all legal fees and costs. Client will also notify Attorney of any changes to Client’s Address and Contact information. Client understands that Attorney cannot guarantee the admission of the trademark to the USPTO and that the application may result in denial of the Client’s trademark. Client also understands that, in order to obtain a federal trademark, Client must provide/sell a reasonably significant number of Client’s goods/services to customers in at least two different States. Client may not need to provide the goods/services in multiple states at the time of filing. If Client is not yet engaged in “interstate commerce”, we will file the application on an “Intent to use” basis and Client will file a Statement of Use at a later time, paying a Government Fee of $150/Class. If Client instead decides to have us file an “Extension” of time request to submit the Statement of use (of which there are a total of 5 extensions – each for a period of 6 months), client will be responsible for the government filing fees in addition to our legal service fee of $175.00.
                                                                        <br/>
                                                                        <strong>3. FEE.</strong> The Flat Fee for the Legal Services agreed to by the Attorney and Client is $450.00 USD (the “Flat Fee“) per trademark application. Client understands that because he/she/it chose to not hire Us to conduct a preliminary trademark search for existing marks and/or to evaluate the viability of the trademark vis-à-vis trademark law, Client’s mark may be rejected. The rules of professional conduct for attorneys in the State of New York in the United States of America require that unearned client’s fees advanced by clients to attorneys be kept in a separate “trust' account until the fees are earned and/or the representation terminated by either party. The Legal Services are completed and the Flat Fee is earned when Attorney drafts trademark application to Client with for confirmation before filing. Client may be entitled to partial refund if the Client terminates this agreement prior to the completion of Attorney completing the Legal Services.
                                                                        <br/>
                                                                        <strong>4. COSTS AND EXPENSES.</strong> The US Government fee is $350.00 per international class for trademark application filings. Please note; You MUST ultimately provide your goods/services to customers in “interstate commerce” (sell to customers from at least 2 States) in order to be eligible for a federally registered trademark. in the event that you are not currently using your mark in interstate commerce, we can file an Intent-To-Use Application, which will cost an additional $150.00 Government filing fee at a later point in time, when we submit a Statement of Use illustrating the Mark’s use in commerce. In the event that we do file an Intent-To-Use Application, you will be responsible for the $150.00 Government filing fee at that later date. If you instead decide to have us file an “Extension” of time request to submit the Statement of use, you will be responsible for the government filing fees in addition to our legal service fee of $175.00. Finally, our fees for any other legal services to be performed in connection with the Trademark matter, such as responding to potential Office Actions from the Trademark Office, both for procedural and substantive matters will be determined on a “Per-Project Basis”. Hopefully, we will not need to respond to any such Office Actions but if we do, we will of course discuss these matters with you in advance before you are billed for any additional work
                                                                        <br/>
                                                                        <strong>5. WORK PRODUCT:</strong> The writings, notes, memoranda, reports of conversations, research and confidential materials which we prepare will be maintained in strict confidence and under the provisions of the attorney-client privilege.
                                                                        <br/>
                                                                        <strong>6. TERMINATION:</strong> As is appropriate in any professional relationship, You may terminate our engagement at any time upon reasonable notice to us, and we retain the right to terminate this agreement as well. In the event that our representation is terminated, you agree to pay all bills thereafter rendered covering expenses incurred prior to the termination.
                                                                        <br/>
                                                                        <strong>7. ENTIRE AGREEMENT / SEVERABILITY.</strong> This Agreement contains the entire agreement of the Parties. No other agreement, statement, or promise made on or before the effective date of this Agreement will be binding on the Parties. If any provision of this Agreement is held by a court or other tribunal of competent jurisdiction, in whole or in part, to be unenforceable for any reason, the remainder of that provision and of the entire Agreement will be severable and remain in effect.
                                                                        <br/>
                                                                        <strong>8. CLIENT ASSENT.</strong> While we agree to represent you to the best of our ability, you must understand that no results can be guaranteed, and we do not warrant that your trademark will necessarily be registered by the USPTO. By Submitting payment, Client agrees to the terms of this agreement.
                                                                    </template>
                                                                    <template v-else>
                                                                        <strong>1. THE PARTIES / EFFECTIVE DATE.</strong> This Agreement is made between Cohn Legal, PLLC (“Attorney“) and You (“Client“) and is effective as of the latest date of signing by Client.
                                                                        <br/>
                                                                        <strong>2. LEGAL SERVICES PROVIDED,</strong> RESPONSIBILITIES OF ATTORNEY AND CLIENT. The Legal Services to be provided by Attorney to Client are the search of the Federal, USPTO database for identical or sufficiently similar trademarks to the Client’s, provide the results of the search results, preparation and filing of Client’s trademark application, monitoring Client’s trademark application once filed, and responding to any “Procedural“ Office Actions issued by the USPTO which require thirty (30) minutes of time or less to answer (“Legal Services“). All additional services, namely responding to Substantive office actions including “Likelihood of Confusion rejections“ and “Descriptive rejections“ will be billed according to a per project basis. These additional charges will be discussed with the Client before Attorney commences work. Client will be cooperative and responsive, providing necessary information and monies for all legal fees and costs. Client will also notify Attorney of any changes to Client’s Address and Contact information. Client understands that Attorney cannot guarantee the admission of the trademark to the USPTO and that the application may result in denial of the Client’s trademark.
                                                                        <br/>
                                                                        <strong>3. FEE.</strong> The Flat Fee for the Legal Services agreed to by the Attorney and Client is $650.00 USD (the “Flat Fee“) per trademark application. This legal fee also includes a $325.00 fee for the Trademark Search of each mark in the USPTO register. In the event that we find your Trademark/s during our search, you will have an additional two (2) opportunities to provide us with prospective trademarks to search. If after the third mark is searched and rejected for intelligibility, you may provide us with up to an additional 3 names to search for an additional $325.00 OR you may request a refund of your original payment, minus the $325.00 search fee (per trademark). The rules of professional conduct for attorneys in the State of New York in the United States of America require that unearned clients fees advanced by clients to attorneys be kept in a separate “trust' account until the fees are earned and/or the representation terminated by either party. The Legal Services are completed and the Flat Fee is earned when Attorney provides the trademark search results and a draft trademark application to Client with for confirmation before filing. Client may be entitled to partial refund if the Client terminates this agreement prior to the completion of Attorney completing the Legal Services.
                                                                        <br/>
                                                                        <strong>4. COSTS AND EXPENSES.</strong> The US Government fee is $350.00 per international class for trademark application filings. Please note; You MUST ultimately provide your goods/services to customers in “interstate commerce” (sell to customers from at least 2 States) in order to be eligible for a federally registered trademark. in the event that you are not currently using your mark in interstate commerce, we can file an Intent-To-Use Application, which will cost an additional $150.00 Government filing fee at a later point in time, when we submit a Statement of Use illustrating the Mark’s use in commerce. In the event that we do file an Intent-To-Use Application, you will be responsible for the $150.00 Government filing fee at that later date. If you instead decide to have us file an “Extension” of time request to submit the Statement of use, you will be responsible for the government filing fees in addition to our legal service fee of $175.00. Finally, our fees for any other legal services to be performed in connection with the Trademark matter, such as responding to potential Office Actions from the Trademark Office, both for procedural and substantive matters will be determined on a “Per-Project Basis”. Hopefully, we will not need to respond to any such Office Actions but if we do, we will of course discuss these matters with you in advance before you are billed for any additional work.
                                                                        <br/>
                                                                        <strong>5. WORK PRODUCT:</strong> The writings, notes, memoranda, reports of conversations, research and confidential materials which we prepare will be maintained in strict confidence and under the provisions of the attorney-client privilege.
                                                                        <br/>
                                                                        <strong>6. TERMINATION:</strong> As is appropriate in any professional relationship, You may terminate our engagement at any time upon reasonable notice to us, and we retain the right to terminate this agreement as well. In the event that our representation is terminated, you agree to pay all bills thereafter rendered covering expenses incurred prior to the termination.
                                                                        <br/>
                                                                        <strong>7. ENTIRE AGREEMENT / SEVERABILITY.</strong> This Agreement contains the entire agreement of the Parties. No other agreement, statement, or promise made on or before the effective date of this Agreement will be binding on the Parties. If any provision of this Agreement is held by a court or other tribunal of competent jurisdiction, in whole or in part, to be unenforceable for any reason, the remainder of that provision and of the entire Agreement will be severable and remain in effect.
                                                                        <br/>
                                                                        <strong>8. CLIENT ASSENT.</strong> While we agree to represent you to the best of our ability, you must understand that no results can be guaranteed, and we do not warrant that your trademark will necessarily be registered by the USPTO. By Submitting payment, Client agrees to the terms of this agreement.
                                                                    </template>
                                                                </div>
                                                                <div class="checkbox check-default mar-bottom-15"
                                                                     style="margin-bottom:5px; margin-left:5px;">
                                                                    <label for="terms_of_service" style="line-height: 17px;"><input
                                                                        type="checkbox" name="terms_of_service" value="true"
                                                                        id="terms_of_service"
                                                                        style="position:relative; margin-left:0;">&nbsp;<span
                                                                        class="required">*</span>I Accept the Terms of Service.<br/><small
                                                                        style="margin-left:15px;">I have read, understand, &amp;
                                                                        agree to the terms of service.</small></label>
                                                                </div>
                                                                <label style="font-weight: bolder;padding-left: 10px; margin-bottom: 5px;">Agreed To And Accepted By: <span class="required">*</span></label>
                                                                <div class="signature-block">
                                                                    <div class="img-wrap">
                                                                        <div class="img"></div>
                                                                    </div>
                                                                    <div class="right">
                                                                        <p v-if="signatureName">{{ signatureName }}</p>
                                                                        <div class="sign-wrap"
                                                                             style="width: 100%; position: relative;">
                                                                            <div class="order-sign" style="width: 100%;"></div>
                                                                            <Vue3Signature
                                                                                ref="signature1"
                                                                                :sigOption="state.option"
                                                                                :w="'238px'"
                                                                                :h="'100px'"
                                                                                class="example"
                                                                                @click.native="changeSignature"
                                                                            ></Vue3Signature>
                                                                            <a v-if="!isEmptySignature" @click.prevent="clear" class="clear-signature" style="position: absolute; bottom: 0px; left: 3px;" href="#" data-v-0968b716=""><svg class="removeSelect" width="24" height="24" viewBox="0 0 24 24" fill="#555" xmlns="http://www.w3.org/2000/svg" data-v-0968b716=""><path d="M18 5.99994C17.8125 5.81247 17.5582 5.70715 17.293 5.70715C17.0278 5.70715 16.7735 5.81247 16.586 5.99994L12 10.5859L7.414 5.99994C7.22647 5.81247 6.97216 5.70715 6.707 5.70715C6.44184 5.70715 6.18753 5.81247 6 5.99994C5.81253 6.18747 5.70721 6.44178 5.70721 6.70694C5.70721 6.9721 5.81253 7.22641 6 7.41394L10.586 11.9999L6 16.5859C5.81253 16.7735 5.70721 17.0278 5.70721 17.2929C5.70721 17.5581 5.81253 17.8124 6 17.9999C6.18753 18.1874 6.44184 18.2927 6.707 18.2927C6.97216 18.2927 7.22647 18.1874 7.414 17.9999L12 13.4139L16.586 17.9999C16.7735 18.1874 17.0278 18.2927 17.293 18.2927C17.5582 18.2927 17.8125 18.1874 18 17.9999C18.1875 17.8124 18.2928 17.5581 18.2928 17.2929C18.2928 17.0278 18.1875 16.7735 18 16.5859L13.414 11.9999L18 7.41394C18.1875 7.22641 18.2928 6.9721 18.2928 6.70694C18.2928 6.44178 18.1875 6.18747 18 5.99994Z" fill="#555" data-v-0968b716=""></path></svg></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="signature-block">
                                                                    <div class="img-wrap">
                                                                        <p>{{ datStr }}</p>
                                                                    </div>
                                                                    <div class="right">
                                                                        <p>Please Draw Your Signature</p>
                                                                    </div>
                                                                </div>
                                                                <div style="padding: 0 15px; text-align:center">
                                                                    <a
                                                                    @click.prevent="sendPayment"
                                                                    class="btn btn-orange btn-block" href="javascript:;"
                                                                    id="payment-button-submit">Place Order <i
                                                                    class="fa fa-angle-right"></i></a></div>

                                                            </div>
                                                            <div style="padding: 0 15px; color:red;" id="messages"></div>
                                                            <div class="lock"><i class="icon-ok-sign"></i> 100% Secure Payment</div>

                                                        </div>
                                                        <div class="text-center">
                                                            <h3 class="m-t-40">Still want to chat? We are here to help. Please give us a
                                                                call</h3>
                                                            <div class="phone-number">
                                                                PH: <a href="tel:877-721-4579">212-203-0957</a><br/>
                                                                <span>Mon-Fri 9am-6pm</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a @click.prevent="backStepBtn()" class="btn btn-orange backStepBtn" href="javascript:;" id="backStepBtn1" style="text-decoration: underline;">BACK <i
                                                    class="fa fa-angle-left"></i></a>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div><!-- #content -->
                    </div>
                </div>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script setup>
import DropZone from '@/components/DropZone.vue'
import Owner from '@/components/trademark-registration-process/owner.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import {to_top} from "@/helper";

import {
    ref,
    reactive,
    defineAsyncComponent,
    defineEmits,
    onMounted,
    computed, watch
} from "vue";
import { useRoute, useRouter } from 'vue-router';
import config from '../../../config.js'

const listClassTypeGoods = ref({
    '': 'Select Product Category (Most Similar to your Product/s)',
    '001 - Chemicals': '001 - Chemicals',
    '002 - Paints': '002 - Paints',
    '003 - Cosmetics and Cleaning Products': '003 - Cosmetics and Cleaning Products',
    '004 - Lubricants and Fuels': '004 - Lubricants and Fuels',
    '005 - Pharmaceuticals': '005 - Pharmaceuticals',
    '006 - Metal Products': '006 - Metal Products',
    '007 - Machinery': '007 - Machinery',
    '008 - Hand Tools': '008 - Hand Tools',
    '009 - Computer and Software and Electrical and Scientific Products': '009 - Computer and Software and Electrical and Scientific Products',
    '010 - Medical Instruments': '010 - Medical Instruments',
    '011 - Environmental Control Apparatus': '011 - Environmental Control Apparatus',
    '012 - Vehicles': '012 - Vehicles',
    '013 - Firearms and Explosives and Fireworks': '013 - Firearms and Explosives and Fireworks',
    '014 - Jewelry and Precious Metals and Watches': '014 - Jewelry and Precious Metals and Watches',
    '015 - Musical Instruments': '015 - Musical Instruments',
    '016 - Paper Goods and Printed Material': '016 - Paper Goods and Printed Material',
    '017 - Rubber Products': '017 - Rubber Products',
    '018 - Leather Products (not clothing)': '018 - Leather Products (not clothing)',
    '019 - Building Materials (non-metallic)': '019 - Building Materials (non-metallic)',
    '020 - Furniture': '020 - Furniture',
    '021 - Houseware and Glass Products': '021 - Houseware and Glass Products',
    '022 - Ropes and Tents and Sails and Bags and Fiber products': '022 - Ropes and Tents and Sails and Bags and Fiber products',
    '023 - Yarns and Threads': '023 - Yarns and Threads',
    '024 - Fabrics and Textiles': '024 - Fabrics and Textiles',
    '025 - Clothing and Footwear': '025 - Clothing and Footwear',
    '026 - Lace and Ribbons and Embroidery and Fancy Goods': '026 - Lace and Ribbons and Embroidery and Fancy Goods',
    '027 - Floor Coverings': '027 - Floor Coverings',
    '028 - Toys and Sporting Goods': '028 - Toys and Sporting Goods',
    '029 - Meat and Fish and Poultry and Processed Food Products': '029 - Meat and Fish and Poultry and Processed Food Products',
    '030 -  Staple Foods': '030 -  Staple Foods',
    '031 -  Natural Agricultural Products': '031 -  Natural Agricultural Products',
    '032 - Light Beverages': '032 - Light Beverages',
    '033 -  Wines and Spirits': '033 -  Wines and Spirits',
    '034 - Smokers Articles': '034 - Smokers Articles'
})
const listClassTypeService = ref({
    '': 'Select Service Category (Most Similar to your Service/s)',
    '035 - Advertising and Business Management and Office Functions': '035 - Advertising and Business Management and Office Functions',
    '036 - Insurance and Financial and Real Estate Affairs': '036 - Insurance and Financial and Real Estate Affairs',
    '037 - Construction and Repair and Installation Services': '037 - Construction and Repair and Installation Services',
    '038 - Telecommunication/Communication Services': '038 - Telecommunication/Communication Services',
    '039 - Transport and Storage and Travel': '039 - Transport and Storage and Travel',
    '040 - Treatment of Materials': '040 - Treatment of Materials',
    '041 - Education and Entertainment and Sporting and Cultural Activities': '041 - Education and Entertainment and Sporting and Cultural Activities',
    '042 - Computer and Software services and Scientific Services': '042 - Computer and Software services and Scientific Services',
    '043 - Restaurant and Hotel Services': '043 - Restaurant and Hotel Services',
    '044 - Medical and Beauty and Veterinarian Services': '044 - Medical and Beauty and Veterinarian Services',
    '045 - Legal and Personal and Security services': '045 - Legal and Personal and Security services'
})

const popoverTrigger = ref('hover')
const skipTrademarkSearch = ref('')
const paymentInformationShow = ref(false)
const billingInformationShow = ref(false)
const legalServicesInfoShow = ref(false)
const governmentFeeInfoShow = ref(false)
const names = ref([])
const logos = ref([])
const slogans = ref([])
const categoryPrice = ref(350)
const class_type = ref('')
const tm_type = ref('')
const class_description = ref('')
const ownership_type = ref('')
const ownershipIndividuals = ref([])
const ownershipCompanies = ref([])
const paymentForm = ref({
    billing_address: '',
    billing_city: '',
    billing_state: '',
    billing_zip_code: ''
})
const datStr = ref('')
const pageNum = ref(1)

const state = reactive({
    option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(248, 248, 248)"
    },
})

const signature1 = ref(null)
const isEmptySignature = ref(true)

const clear = () => {
    signature1.value.clear()
    isEmptySignature.value = true
}
const changeSignature = () => {
    isEmptySignature.value = signature1.value.isEmpty()
}

function vdropzoneFileAdded(file, key){
    logos.value[key]['file'] = file[0]
    $('.logo_top' + key + ' .file-input').removeClass('has-error');
    $('.logo_top' + key).find('.e-text').remove();
    var forms = document.querySelectorAll('.form_box_' + key);
    var label = forms[0].querySelector('label')
    label.textContent = file[0].name;
    console.log(11)
    console.log(file[0].name)
}

function setFileLater(event, key) {
    if (event.target.checked) {
        $('.logo_top' + key + ' .file-input').removeClass('has-error');
        $('.logo_top' + key).find('.e-text').remove();
        logos.value[key]['file'] = ''
    }
    setTimeout(initDragDrop, 500)
}

let recaptchaScript = document.createElement('script')
recaptchaScript.setAttribute('src', 'https://api.chargeio.com/assets/api/v1/chargeio.min.js')
document.head.appendChild(recaptchaScript)
import jQuery from "jquery";

recaptchaScript.addEventListener('load', function() {
    jQuery(document).ready(function () {
        ChargeIO.init({ public_key: 'm_CFB5taM1SwSHkhbiYAUtBw' });
        function validateCreditCardNumber(cardNumber) {
            cardNumber = cardNumber.split(' ').join("");
            if (parseInt(cardNumber) <= 0 || (!/\d{15,16}(~\W[a-zA-Z])*$/.test(cardNumber)) || cardNumber.length > 16) {
                return false;
            }
            var carray = new Array();
            for (var i = 0; i < cardNumber.length; i++) {
                carray[carray.length] = cardNumber.charCodeAt(i) - 48;
            }
            carray.reverse();
            var sum = 0;
            for (var i = 0; i < carray.length; i++) {
                var tmp = carray[i];
                if ((i % 2) != 0) {
                    tmp *= 2;
                    if (tmp > 9) {
                        tmp -= 9;
                    }
                }
                sum += tmp;
            }
            return ((sum % 10) == 0);
        }

        function cardType(num) {

            if (num.match(/^6011/)) {
                return 'disc'; //discover
            } /*else if (num.match(/^4026/)) {
                    return 'front';//electron
                } else if (num.match(/^5019/)) {
                    return 'dankort';
                } else if (num.match(/^636/)) {
                    return 'interpayment';
                } */else if (num.match(/^(?:2131|1800|35\d{3})/)) {
                return 'jbс';
            } else if (num.match(/^5[1-5]\d/)) {
                return 'mc';
            } else if (num.match(/^3(?:0[0-5]|[68][0-9])[0-9]/)) {
                return 'dc';
            } else if (num.match(/^4\d/)) {
                return 'visa';
            } else if (num.match(/^3[47]\d/)) {
                return 'amex';
            } else if (num.match(/^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)/)) {
                return 'maestro';
            }
            return 'front';
        }

        $('[name="number"], [name="name"], [name="exp_month"], [name="exp_year"], [name="cvv"]').focusout(function(e)
        {
            var valueCard = $(this).val();
            if ($(this).attr('name') === "exp_month"){
                if(valueCard > 12 || valueCard < 1){
                    $(this).css('border-color', '#fe9d39');
                    $(this).next().next().text('Expiration month is invalid');
                    $('#payment-button-submit').css('pointer-events', 'none');
                } else {
                    $(this).css('border-color', '#ced4da');
                    $(this).next().next().text('');
                    $('#payment-button-submit').css('pointer-events', 'auto');
                }
            }
            if ($(this).attr('name') === "exp_year"){
                var year = new Date().getFullYear();
                if(valueCard < year){
                    $(this).css('border-color', '#fe9d39');
                    $(this).next().text('Expiration year is invalid');
                    $('#payment-button-submit').css('pointer-events', 'none');
                } else {
                    $(this).css('border-color', '#ced4da');
                    $(this).next().text('');
                    $('#payment-button-submit').css('pointer-events', 'auto');
                }
            }

            if (valueCard.length == 0){
                $(this).css('border-color', '#fe9d39');
                if ($(this).attr('name') === "exp_month"){
                    $(this).next().next().text('Please complete');
                } else {
                    $(this).next().text('Please complete');
                }
            } else {
                $(this).css('border-color', '#ced4da');
                $(this).next().text('');
            }

            if ($(this).attr('name') === "number") {
                if (validateCreditCardNumber(valueCard) === false) {
                    $(this).css('border-color', '#fe9d39');
                    $(this).next().text('Please enter a valid credit card number');
                    $('#payment-button-submit').css('pointer-events', 'none');
                } else {
                    $(this).css('border-color', '#ced4da');
                    $(this).next().text('');
                    $('#payment-button-submit').css('pointer-events', 'auto');
                }
            }

            refreshBlockHeight('paymentInformationInfo')
        });
        function processErrorMessages(messages) {
            var msgList = jQuery('#messages');
            jQuery(msgList).empty();
            jQuery.each(messages, function(index, item) {
                jQuery(msgList).append(item.message);
            });

            jQuery('#messages').show();
            jQuery('#payment-button-submit').text("Place Order");
        }
        $('input[name="number"], [name="exp_month"], [name="exp_year"], [name="cvv"]').keyup(function(e)
        {
            if (/\D/g.test(this.value))
            {
                this.value = this.value.replace(/\D/g, '');
            }
        });
        $('#ck').keyup(function(){
            var val = $(this).val();
            val = val.replace(/[^\d]/g,'');
            var space = val.toString().replace(/\d{4}(?=.)/g, '$& ');
            $('#ck').val(space);
            var type = cardType(val);
            $('#ck').css('background-image', 'url(/' + type + '.jpg)');
        });

        $('body').on('change paste keypress keydown keyup', '.has-error', function(e) {
            if($(this).val().length > 0) {
                if ($(this).hasClass('select_cat')) {
                    $(this).parents('.select_wrapper').find('.e-text').remove();
                } else {
                    $(this).parent().find('.e-text').remove();
                }
                $(this).removeClass('has-error');
            }
        });
    });
});

import http from "@/api/http";
const router = useRouter()

onMounted(() => {
    to_top()

    if($(window).width() < 768) {
        popoverTrigger.value = 'click'
    }

    var d  = new Date();
    let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    let mo = new Intl.DateTimeFormat('en', { month: 'long' }).format(d);
    let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
    datStr.value = `${mo} ${da}th, ${ye}`
    tm_type.value = 'name'
    ownership_type.value = 'Individual'

    if (typeof history.pushState === "function") {
        history.pushState("jibberish", null, null);
        window.onpopstate = function () {
            history.pushState('newjibberish', null, null);
            prevPopstate()
        };
    } else {
        var ignoreHashChange = true;
        window.onhashchange = function () {
            if (!ignoreHashChange) {
                ignoreHashChange = true;
                window.location.hash = Math.random();
                prevPopstate()
            }
            else {
                ignoreHashChange = false;
                prevPopstate()
            }
        };
    }
});

watch(legalServicesInfoShow, () => {
    if (legalServicesInfoShow.value) {
        let height = $('.legalServicesInfo table').height()
        $('.legalServicesInfo').css("height", height + 'px')
        $('.legalServicesInfo').css("border-bottom", '1px solid #999')
    } else {
        $('.legalServicesInfo').css("height", '0px')
        $('.legalServicesInfo').css("border-bottom", 'none')
    }
});
watch(governmentFeeInfoShow, () => {
    if (governmentFeeInfoShow.value) {
        let height = $('.governmentFeeInfo table').height()
        $('.governmentFeeInfo').css("height", height + 'px')
        $('.governmentFeeInfo').css("border-bottom", '1px solid #999')
    } else {
        $('.governmentFeeInfo').css("height", '0px')
        $('.governmentFeeInfo').css("border-bottom", 'none')
    }
});
watch(class_type, () => {
    if (class_type.value == 'Goods') {
        for (let i = 0; i < names.value.length; i++) {
            names.value[i].categoriesGoods = ['']
            names.value[i].categoriesServices = []
        }
        for (let i = 0; i < logos.value.length; i++) {
            logos.value[i].categoriesGoods = ['']
            logos.value[i].categoriesServices = []
        }
        for (let i = 0; i < slogans.value.length; i++) {
            slogans.value[i].categoriesGoods = ['']
            slogans.value[i].categoriesServices = []
        }
    } else if (class_type.value == 'Services') {
        for (let i = 0; i < names.value.length; i++) {
            names.value[i].categoriesGoods = []
            names.value[i].categoriesServices = ['']
        }
        for (let i = 0; i < logos.value.length; i++) {
            logos.value[i].categoriesGoods = []
            logos.value[i].categoriesServices = ['']
        }
        for (let i = 0; i < slogans.value.length; i++) {
            slogans.value[i].categoriesGoods = []
            slogans.value[i].categoriesServices = ['']
        }
    } else if (class_type.value == 'Both') {
        for (let i = 0; i < names.value.length; i++) {
            names.value[i].categoriesGoods = ['']
            names.value[i].categoriesServices = ['']
        }

        for (let i = 0; i < logos.value.length; i++) {
            logos.value[i].categoriesGoods = ['']
            logos.value[i].categoriesServices = ['']
        }

        for (let i = 0; i < slogans.value.length; i++) {
            slogans.value[i].categoriesGoods = ['']
            slogans.value[i].categoriesServices = ['']
        }
    }
});
watch(ownership_type, () => {
    if (ownership_type.value == 'Individual') {
        ownershipIndividuals.value = []
        ownershipCompanies.value = []
        addDefaultOwnershipIndividual()
    } else if (ownership_type.value == 'Company') {
        ownershipIndividuals.value = []
        ownershipCompanies.value = []
        addDefaultOwnershipCompany()
    }
});
watch(tm_type, () => {
    class_type.value = ''
    if (tm_type.value == 'name') {
        names.value = [{value: '', categoriesGoods: [], categoriesServices: []}]
        logos.value = []
        slogans.value = []
    } else if (tm_type.value == 'logo') {
        names.value = []
        logos.value = [{file: '', fileLater: false, categoriesGoods: [], categoriesServices: []}]
        slogans.value = []
        setTimeout(initDragDrop, 500)
    } else if (tm_type.value == 'slogan') {
        names.value = []
        logos.value = []
        slogans.value = [{value: '', categoriesGoods: [], categoriesServices: []}]
    } else if (tm_type.value == 'name_logo') {
        names.value = [{value: '', categoriesGoods: [], categoriesServices: []}]
        logos.value = [{file: '', fileLater: false, categoriesGoods: [], categoriesServices: []}]
        slogans.value = []
        setTimeout(initDragDrop, 500)
    } else if (tm_type.value == 'name_logo_slogan') {
        names.value = [{value: '', categoriesGoods: [], categoriesServices: []}]
        logos.value = [{file: '', fileLater: false, categoriesGoods: [], categoriesServices: []}]
        slogans.value = [{value: '', categoriesGoods: [], categoriesServices: []}]
        setTimeout(initDragDrop, 500)
    }
});

const refreshBlockHeight = function (classM) {
    let height = $('.' + classM + '>div').height()
    if (height) {
        $('.' + classM).css("height", height + 'px')
    }
}

function sendPayment() {
    ChargeIO.ready(function() {
        jQuery('#payment-button-submit').text("Place Order");
        $('.credit-card-number, .exp_year_month, .cvc').text('');

        var e = $("#step_7 [data-required]");
        let flag = 0;
        $(e).each(function() {
            if ($(this).is(":visible") && "" == $.trim($(this).val())) {
                $(this).addClass('has-error');
                $(this).parent().find('.e-text').remove();
                $(this).after('<span class="bold e-text">Please complete</span>');
                refreshBlockHeight('paymentInformationInfo')
                refreshBlockHeight('billingInformationInfo')
                flag = 1;
            }
        });
        if(flag != 0) {
            return false;
        }
        if (signature1.value.isEmpty()) {
            alert('Your signature is required!');
            return false;
        }
        if (!$('input[name=terms_of_service]:checked').val() ) {
            alert('You must have to agree with our terms and conditions.');
            return false;
        }

        $('.preloader').css('display', 'block');
        jQuery('#payment-button-submit').text("Payment Processing");
        var paymentJson = ChargeIO.payment_params(jQuery('#payment-form'));

        ChargeIO.create_token(paymentJson, function(token) {
            const formData = new FormData()
            for (let i = 0; i < logos.value.length; i++) {
                if (logos.value[i]['file']) {
                    formData.append('logo[' + i + ']', logos.value[i]['file'])
                }
            }

            formData.append('data', JSON.stringify({
                skipTrademarkSearch: skipTrademarkSearch.value,
                names: names.value,
                logos: logos.value,
                slogans: slogans.value,
                class_type: class_type.value,
                tm_type: tm_type.value,
                class_description: class_description.value,
                ownership_type: ownership_type.value,
                ownershipIndividuals: ownershipIndividuals.value,
                ownershipCompanies: ownershipCompanies.value,
                sign: signature1.value.save('image/jpeg'),
                token_id: token.id,
                billing_address: paymentForm.value.billing_address,
                billing_city: paymentForm.value.billing_city,
                billing_state: paymentForm.value.billing_state,
                billing_zip_code: paymentForm.value.billing_zip_code,
            }))

            http.post('/trademark-registration-process/done', formData).then((response) => {
                if (response.data.data.key) {
                    const link = document.createElement('a');
                    link.setAttribute('download', 'Trademark_registration_services.pdf');
                    link.href = config.baseURL + '/api/trademark-registration-process/document/' + response.data.data.key
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    router.push('/trademark-registration-process/thank-you')
                }
            }).catch(error => {
              $('.preloader').css('display', 'none');
              if(response == 'Card type is not accepted'){
                $('input[name="number"]').css('border-color', '#fe9d39');
                $('.credit-card-number').text(response);
              }else if(response == 'Card number is invalid' || data == 'Card number is invalid'){
                $('input[name="number"]').css('border-color', '#fe9d39');
                $('.credit-card-number').text(response);
              }else if(response == 'Expiration month is invalid'){
                $('input[name="exp_month"]').css('border-color', '#fe9d39');
                $('.exp_year_month').text(response);
              }else if(response == 'Card is expired' || response == 'Expiration year is invalid'){
                $('input[name="exp_year"]').css('border-color', '#fe9d39');
                $('.exp_year_month').text(response);
              }else if(response == 'Card code is invalid'){
                $('input[name="cvv"]').css('border-color', '#fe9d39');
                $('.cvc').text(response);
              }else if(response == 'Card was declined due to limits exceeded'){
                $('input[name="cvv"]').css('border-color', '#fe9d39');
                $('.cvc').text(response);
              }else{
                processErrorMessages([ { "message": data } ]);
              }

              processErrorMessages([ { "message": "An unexpected error occurred" } ]);
            })
        });
    });
}

const paymentInformationShowHandler = function () {
    let startValue = paymentInformationShow.value
    if (paymentInformationShow.value) {
        $('.paymentInformationInfo').css("height", '0px')
        paymentInformationShow.value = false
    } else {
        refreshBlockHeight('paymentInformationInfo')
        paymentInformationShow.value = true
    }

    if (!startValue && billingInformationShow.value) {
        $('.billingInformationInfo').css("height", '0px')
        billingInformationShow.value = false
    }
}
const billingInformationShowHandler = function () {
    let startValue = billingInformationShow.value
    if (billingInformationShow.value) {
        $('.billingInformationInfo').css("height", '0px')
        billingInformationShow.value = false
    } else {
        refreshBlockHeight('billingInformationInfo')
        billingInformationShow.value = true
    }

    if (!startValue && paymentInformationShow.value) {
        $('.paymentInformationInfo').css("height", '0px')
        paymentInformationShow.value = false
    }
}
const billingInformationShowHandlerAddition = function () {
    refreshBlockHeight('billingInformationInfo')
    billingInformationShow.value = true
}

const prevPopstate = function (){
    if (pageNum.value == 2) {
        let response = confirm('Clicking on the back arrow button in your browser may result in loss of data. Instead, please click on the OK at the top of this form to return to the previous page.');
        if (response) {
            backStepBtn()
        }
    }
}

const number_format = function (number) {
    let i, j, kw, kd, km;
    let decimals = 2
    let dec_sign = '.'
    let ths_sign = ','

    i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

    if( (j = i.length) > 3 ){
        j = j % 3;
    } else{
        j = 0;
    }

    km = (j ? i.substr(0, j) + ths_sign : "");
    kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ths_sign);
    kd = (decimals ? dec_sign + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

    let num = km + kw + kd;

    return num
}

const nextStepBtn = function (){
    jQuery('html, body').animate({scrollTop : 0},800);
    var e = $("#step_1 [data-required]"),
        t = !0,
        flag = 0;
    $(e).each(function(i) {

        if (($(this).is(':visible') && $.trim($(this).val()) == "")) {
            $(this).addClass('has-error');

            if ($(this).hasClass('select_cat')) {
                $(this).parents('.select_wrapper').find('.e-text').remove();
                $(this).parent().after('<span class="bold e-text" style="display: inherit;">Please complete</span>');
            } else {
                $(this).parent().find('.e-text').remove();
                $(this).parent().append('<span class="bold e-text">Please complete</span>');
            }
            if (flag == 0) {
                $('html, body').animate({
                    scrollTop: $(this).offset().top - 200
                }, 1000);
            }
            flag = 1;

        }
    });

    if(flag == 0) {
        $('#step_1').addClass('hide');
        $('#step_1_2').addClass('hide');
        $('#step_1_3').addClass('hide');
        $('#step_7').removeClass('hide');
        $('#facebook_pixel_tracker').val(1);
        $('.cardholder-name').focus();
        pageNum.value = 2
        legalServicesInfoShow.value = false
        governmentFeeInfoShow.value = false
        paymentInformationShowHandler()
    }
}
const backStepBtn = function (){
    jQuery('html, body').animate({scrollTop : 0},800);
    $('#step_1').removeClass('hide');
    $('#step_1_2').removeClass('hide');
    $('#step_1_3').removeClass('hide');
    $('#step_7').addClass('hide');
    $('#facebook_pixel_tracker').val('');
    pageNum.value = 1
    $('.paymentInformationInfo').css("height", '0px')
    paymentInformationShow.value = false
    $('.billingInformationInfo').css("height", '0px')
    billingInformationShow.value = false
}
const addDefaultOwnershipIndividual = function (){
    ownershipIndividuals.value.push({
        first_name: '',
        last_name: '',
        citizenship: '',
        owner_address: '',
        owner_city: '',
        owner_state: '',
        owner_zip: '',
        owner_phone: '',
        owner_email: ''
    })
}
const addDefaultOwnershipCompany = function (){
    ownershipCompanies.value.push({
        organization_name: '',
        organization_type: '',
        organization_formation_location: '',
        first_name: '',
        last_name: '',
        citizenship: '',
        owner_address: '',
        owner_city: '',
        owner_state: '',
        owner_zip: '',
        owner_phone: '',
        owner_email: ''
    })
}
const addName = function (){
    names.value.push({value: '', categoriesGoods: [], categoriesServices: []})
    for (let i = 0; i < names.value.length; i++) {
        names.value[i].categoriesGoods = []
        names.value[i].categoriesServices = []
    }
    class_type.value = ''
}
const addLogo = function (){
    logos.value.push({file: '', fileLater: false, categoriesGoods: [], categoriesServices: []})
    for (let i = 0; i < logos.value.length; i++) {
        logos.value[i].categoriesGoods = []
        logos.value[i].categoriesServices = []
    }
    class_type.value = ''
    setTimeout(initDragDrop, 500)
}
const addSlogan = function (){
    slogans.value.push({value: '', categoriesGoods: [], categoriesServices: []})
    for (let i = 0; i < slogans.value.length; i++) {
        slogans.value[i].categoriesGoods = []
        slogans.value[i].categoriesServices = []
    }
    class_type.value = ''
}
const itemPrice = computed(() => {
    if (skipTrademarkSearch.value) {
        return 450
    } else {
        return 650
    }
})
const mainTextAdditionals = computed(() => {
    if (skipTrademarkSearch.value) {
        return 'TM USPTO Filing + Government Fee'
    } else {
        return 'TM USPTO Search & Filing + Government Fee'
    }
})
const signatureName = computed(() => {
    if (ownership_type.value == 'Individual' && ownershipIndividuals.value[0]) {
        return ownershipIndividuals.value[0].first_name + ' ' + ownershipIndividuals.value[0].last_name
    } else if (ownership_type.value == 'Company') {
        return ''
    }
})
const itemsCount = computed(() => {
    return names.value.length + logos.value.length + slogans.value.length
})
const categoriesCount = computed(() => {
    let num = 0
    let alternativeNum = 0
    for (let i = 0; i < names.value.length; i++) {
        num += names.value[i].categoriesGoods.length
        num += names.value[i].categoriesServices.length
        alternativeNum++
    }
    for (let i = 0; i < logos.value.length; i++) {
        num += logos.value[i].categoriesGoods.length
        num += logos.value[i].categoriesServices.length
        alternativeNum++
    }
    for (let i = 0; i < slogans.value.length; i++) {
        num += slogans.value[i].categoriesGoods.length
        num += slogans.value[i].categoriesServices.length
        alternativeNum++
    }

    return num ? num : alternativeNum
})
const totalItemsPrice = computed(() => {
    return itemsCount.value * itemPrice.value
})
const totalCategoriesPrice = computed(() => {
    return categoriesCount.value * categoryPrice.value
})
const totalPrice = computed(() => {
    return totalItemsPrice.value + totalCategoriesPrice.value
})

function initDragDrop() {
    // applying the effect for every form
    var forms = document.querySelectorAll('.box');
    Array.prototype.forEach.call(forms, function (form) {
        var input = form.querySelector('input[type="file"]'),
            label = form.querySelector('label'),
            errorMsg = form.querySelector('.box__error span'),
            restart = form.querySelectorAll('.box__restart');
            // showFiles = function (files) {
            //     this.test()
            //     label.textContent = files.length > 1 ? (input.getAttribute('data-multiple-caption') || '').replace('{count}', files.length) : files[0].name;
            // };

            // drag&drop files if the feature is available
            form.classList.add('has-advanced-upload'); // letting the CSS part to know drag&drop is supported by the browser

        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (event) {
            form.addEventListener(event, function (e) {
                // preventing the unwanted behaviours
                e.preventDefault();
                e.stopPropagation();
            });
        });
        ['dragover', 'dragenter'].forEach(function (event) {
            form.addEventListener(event, function () {
                form.classList.add('is-dragover');
            });
        });
        ['dragleave', 'dragend', 'drop'].forEach(function (event) {
            form.addEventListener(event, function () {
                form.classList.remove('is-dragover');
            });
        });
        // form.addEventListener('drop', function (e) {
        //     droppedFiles = e.dataTransfer.files; // the files that were dropped
        //     showFiles(droppedFiles);
        //     this.test()
        // });

        // restart the form if has a state of error/success
        Array.prototype.forEach.call(restart, function (entry) {
            entry.addEventListener('click', function (e) {
                e.preventDefault();
                form.classList.remove('is-error', 'is-success');
                input.click();
            });
        });

        // Firefox focus bug fix for file input
        // input.addEventListener('focus', function () {
        //     input.classList.add('has-focus');
        // });
        // input.addEventListener('blur', function () {
        //     input.classList.remove('has-focus');
        // });

    });
};
</script>

<style src='@/styles/trademark-registration-process.css' scoped></style>

<style>
.page-trademark-registration-process > .home.page-template-default {
    /*display: none;*/
}
.file-later-block input{
    width: 18px;
    height: 18px;
    outline: 3px solid orange!important;
    outline-offset: -3px!important;
    position: relative;
    top: 2px;
}
.file-later-block input[type='checkbox'] {
    accent-color: orange;
}
.label-inside{
    font-size: 14px;
    margin-left: 28px;
}
.checkbox-container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 18px;
    width: 18px;
    background-color: #fff;
    border: 2px orange solid;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
    background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
    background-color: white;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
    left: 4px;
    top: 1px;
    width: 7px;
    height: 10px;
    border: solid orange;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(35deg);
    -ms-transform: rotate(35deg);
    transform: rotate(35deg);
}
</style>
